import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ControlloPassword } from './controlloPassword';
import { Store } from '@ngrx/store';
import { AppState, getMyAuth } from 'src/app/store/app.state';
import { map, tap } from 'rxjs/operators';
import { Utente } from '../../models/utente.model';
import * as authActions from '../../../auth/store/auth.actions';
import { Actions } from '@ngrx/effects';
import { SubSink } from 'subsink';


@Component({
  selector: 'app-modale-utente',
  templateUrl: './modale-utente.component.html',
  styleUrls: ['./modale-utente.component.css']
})
export class ModaleUtenteComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  /**Emettitore dell'evento di chiusura */
  @Output() close = new EventEmitter<void>();
  formModaleUtenti = new FormGroup({});
  hide = true;

  formLinguistica = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private actions$: Actions,
  ) {
    /**Form contenente i campi di input, usiamo Reactive forms*/
    this.formModaleUtenti = fb.group({
      name: new FormControl(''),
      email: new FormControl(''),
      password: new FormControl(''),
      newPassword: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}')]),
      confirmedPassword: new FormControl('', Validators.required)
    }, {
      validator: ControlloPassword('newPassword', 'confirmedPassword')
    })
  }

  utenteLoggato: Utente;

  newPassword = '';
  confirmedPassword = '';

  bottoneAbilitato = false;

  /**Metodo dell'interfaccia Oninit per il recupero dei dati dell'utente loggato*/
  ngOnInit() {

    this.subs.sink = this.store.select(getMyAuth).pipe(
      map(data => {
        this.utenteLoggato = data.loggedUser;
      })
    ).subscribe();


    this.formLinguistica = new FormGroup({
      spellCheckerEnabled: new FormControl( this.utenteLoggato.settings.spellCheckerEnabled ? (this.utenteLoggato.settings.spellCheckerEnabled === 'true' ? true : false ) : false),
      suggestionEnabled: new FormControl( this.utenteLoggato.settings.suggestionEnabled ? (this.utenteLoggato.settings.suggestionEnabled === 'true' ? true : false ) : true),
      suggestionCount: new FormControl(this.utenteLoggato.settings.suggestionCount ? this.utenteLoggato.settings.suggestionCount : '5'),
      suggestionMinRank: new FormControl(this.utenteLoggato.settings.suggestionMinRank ? (+this.utenteLoggato.settings.suggestionMinRank * 100) : '40', [Validators.min(1), Validators.max(100)]),
      suggestionRankVisible: new FormControl(this.utenteLoggato.settings.suggestionRankVisible ? (this.utenteLoggato.settings.suggestionRankVisible === 'true' ? true : false): false),
      suggestionUseCosines: new FormControl( this.utenteLoggato.settings.suggestionUseCosines ? (this.utenteLoggato.settings.suggestionUseCosines === 'true' ? true : false) : false)
    });

   
    this.formModaleUtenti.controls.name.setValue(this.utenteLoggato.name);
    this.formModaleUtenti.controls.email.setValue(this.utenteLoggato.email);

    this.subs.sink = this.formModaleUtenti.valueChanges.pipe(
      tap(data => {
        if (data.name != this.utenteLoggato.name || data.email != this.utenteLoggato.email) {
          this.bottoneAbilitato = true;
        }
        if (this.formModaleUtenti.get('newPassword').valid && this.formModaleUtenti.get('confirmedPassword').valid) {
          this.bottoneAbilitato = true;
        }
      })
    ).subscribe();

    this.subs.sink = this.formLinguistica.get('spellCheckerEnabled').valueChanges.subscribe(
      data => {
        this.store.dispatch(new authActions.StartUpdateLoggedUser([ { user: this.utenteLoggato.id , nomeCampo: 'settings/spellCheckerEnabled', newValue: data }]))
      }
    )

    this.subs.sink = this.formLinguistica.get('suggestionEnabled').valueChanges.subscribe(
      data => {
        this.store.dispatch(new authActions.StartUpdateLoggedUser([ { user: this.utenteLoggato.id , nomeCampo: 'settings/suggestionEnabled', newValue: data }]))
      }
    )

    this.subs.sink = this.formLinguistica.get('suggestionRankVisible').valueChanges.subscribe(
      data => {
        this.store.dispatch(new authActions.StartUpdateLoggedUser([ { user: this.utenteLoggato.id , nomeCampo: 'settings/suggestionRankVisible', newValue: data }]))
      }
    )
    
    this.subs.sink = this.formLinguistica.get('suggestionUseCosines').valueChanges.subscribe(
      data => {
        this.store.dispatch(new authActions.StartUpdateLoggedUser([ { user: this.utenteLoggato.id , nomeCampo: 'settings/suggestionUseCosines', newValue: data }]))
      }
    )
    
  }

  saveUpdateOnFocusOut(evento, nomeCampo: string) {
    let newValue: any = evento.target.value;
    if(nomeCampo === 'suggestionMinRank') {
      newValue = newValue / 100;
    }
    if(!this.utenteLoggato.settings[nomeCampo] || this.utenteLoggato.settings[nomeCampo] !== newValue ) {
      this.store.dispatch(new authActions.StartUpdateLoggedUser([{ user: this.utenteLoggato.id, nomeCampo: 'settings/' + nomeCampo, newValue: newValue }]))
    }
  }

  /**Metodo che emette l'evento di chiusura al click sullo sfondo o sul pulsante relativo*/
  onClose() {
    this.close.emit();
  }

  /**Metodo che salva i dati aggiornati dell'utente loggato */
  onSubmit() {
    let modifiche: { user: number, nomeCampo: string, newValue: any }[] = [];
    if (this.utenteLoggato.name !== this.formModaleUtenti.controls['name'].value) {
      modifiche.push({ user: this.utenteLoggato.id, nomeCampo: 'name', newValue: this.formModaleUtenti.controls['name'].value });
    }
    if (this.utenteLoggato.email !== this.formModaleUtenti.controls['email'].value) {
      modifiche.push({ user: this.utenteLoggato.id, nomeCampo: 'email', newValue: this.formModaleUtenti.controls['email'].value });
    }
    if (
      this.formModaleUtenti.controls.password.value !== '' &&
      this.formModaleUtenti.controls.newPassword.valid &&
      this.formModaleUtenti.controls.confirmedPassword.valid &&
      this.formModaleUtenti.valid
    ) {
      modifiche.push({
        user: this.utenteLoggato.id,
        nomeCampo: 'password',
        newValue:
        {
          currentPassword: this.formModaleUtenti.controls.password.value,
          newPassword: this.formModaleUtenti.controls.newPassword.value
        }
      })
    }
    this.store.dispatch(new authActions.StartUpdateLoggedUser(modifiche));
    this.formModaleUtenti.controls.password.reset('');
    this.formModaleUtenti.controls.newPassword.reset('');
    this.formModaleUtenti.controls.confirmedPassword.reset('');
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
